import { AfterViewInit, Component, OnInit, ViewChild, ɵRuntimeError} from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { IControls } from 'bi-interfaces';
import { ChangePassword_Controls } from './changePassword_Columns';
import { userPermissionsService } from '../shared/userPermissions.service';
import { HttpService } from '../shared/services/HttpClientServices/Http.service';
import { TranslateService } from '@ngx-translate/core';
import { ControlTypes } from "BI-Libraries/BI-Interfaces/projects/bi-interfaces/src/lib/enums/ControlTypes";
import { AlertsService } from '../shared/services/alertService/alerts.service';
import { AdminRouteGuard } from '../core/admin-route.guard';
import { Router } from '@angular/router';
import { SalesBuzzParams } from '../shared/Enums/SalesOrderParams';
import { UserInfo } from '../userInfo';
import { ColViewService } from 'BI-Libraries/BI-Components/projects/bi-modules/src/lib/components/BI-Nav/col-view.service';
import { INavBtn } from 'BI-Libraries/BI-Interfaces/dist/bi-interfaces/lib/interfaces/inav-btn';
import { NavButton } from 'BI-Libraries/BI-Interfaces/dist/bi-interfaces';


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})

export class ChangePasswordComponent implements OnInit , AfterViewInit {
  @ViewChild('ref') listref;
  formGroup!: FormGroup;
  public controlList : IControls[];
  private changePasswordControl: ChangePassword_Controls;
  private _userinfo: any = UserInfo;

  public navButtons: INavBtn = {
    [NavButton.attach]: {
      visibility: false,
      disable: false,
    },
    [NavButton.add]: {
      visibility: false,
      disable: false,
    },
    [NavButton.save]: {
      visibility: false,
      disable: false,
    },
    [NavButton.cancel]: {
      visibility: false,
      disable: false,
    },
    [NavButton.delete]: {
      visibility: false,
      disable: false,
    },
    [NavButton.info]: {
      visibility: false,
      disable: false,
    },
    [NavButton.ColView]: {
      visibility: false,
      disable: false,
    },
  };

  constructor(
    public ColViewService: ColViewService,
    public userPermissions: userPermissionsService,
    private translateService: TranslateService,
    private httpService: HttpService,
    private formBuilder: FormBuilder,
    private _authJWTService: AdminRouteGuard,
    private router: Router,
    private alertsService: AlertsService) 
    {
    if(!this.isLoggedIn()){
      this.router.navigate(["login"]);
    }

    if(this._userinfo.AuthType == 2)
      throw new ɵRuntimeError(4002, this.translateService.instant(`CantBeAccessedFromAnActiveDirectoryAccount`));
    

    this.changePasswordControl = new ChangePassword_Controls();
    this.CreateChangePasswordControlProperties();
    this.controlList = this.changePasswordControl.getControlListByGroup("General");
    this.HandleParms();
   
  }
  ngAfterViewInit(): void {
    this.listref.AlterColumnNumber(1);
  }
  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      CurrentPassword: ['', [Validators.compose([Validators.required,Validators.maxLength(15)])] ],
      NewPassword: ['', [Validators.compose([ Validators.required , Validators.maxLength(15) , WeakPassword , MediumPassword , ComplexPassword ])]],
      NewPasswordConfirm: ['', Validators.required]
    }, {
      validators: NotMatchingPassword
    });

  }
  public ChangePassword(){

    if(this.formGroup.invalid) {
      this.alertsService.showAlertMessage(this.translateService.instant('Please fill out all required fields'), 0);
      return;
    }
    const body = {
      "OldPassword": this.formGroup.controls['CurrentPassword'].value,
      "NewPassword": this.formGroup.controls['NewPassword'].value
    }
    this.httpService.add(`ChangePassword`,body).subscribe(() => {
      this.alertsService.showAlertMessage(this.translateService.instant('SavedSuccessfully'), 2);
    });
    this.formGroup.reset();
  }
  onCancel(){
    this.formGroup.reset();
  }

  GetPageTitle() {
    return this.translateService.instant('ChangeUserPw');
  }
  EnablePasswordContorolforBO;
  PasswordLengthforBO;
  PasswordStrengthforBO;
  HandleParms() {
    this.httpService.get(`HH_PARAMS?$filter=PARAM_ID in (${SalesBuzzParams.EnablePasswordContorolforBO}, ${SalesBuzzParams.PasswordLengthforBO}, ${SalesBuzzParams.PasswordStrengthforBO})`)
      .subscribe(res => {
        this.EnablePasswordContorolforBO = res.value.find(res => res['PARAM_ID'] === SalesBuzzParams.EnablePasswordContorolforBO);
        this.PasswordLengthforBO = res.value.find(res => res['PARAM_ID'] === SalesBuzzParams.PasswordLengthforBO);
        this.PasswordStrengthforBO = res.value.find(res => res['PARAM_ID'] === SalesBuzzParams.PasswordStrengthforBO);
        this.SetPasswordValidations();
      })
  }
  SetPasswordValidations() {
    let Validation = [];
    let ConfirmPasswordValidation = [];
    this.controlList = this.controlList.filter(res => {
      if (res.Name === "NewPassword") {
        if (this.EnablePasswordContorolforBO?.PARAM_VALUE == 1) {
          if (this.PasswordLengthforBO?.PARAM_VALUE) {
            Validation.push(Validators.minLength(Number(this.PasswordLengthforBO?.PARAM_VALUE)))
          }
          if (this.PasswordStrengthforBO?.PARAM_VALUE != null && this.PasswordStrengthforBO.PARAM_VALUE !== ''  && this.PasswordStrengthforBO.PARAM_VALUE != undefined) {
            switch (this.PasswordStrengthforBO.PARAM_VALUE) {
              case "0":
                Validation.push(WeakPassword);
                break;
              case "1":
                Validation.push(MediumPassword);
                break;
              case "2":
                Validation.push(ComplexPassword);
                break;
            }
          }
          res.Validators = Validators.compose(Validation);
        } else {
          res.Validators = null;
        }
      }
      return res;
    });
    this.formGroup.controls['NewPassword'].addValidators(Validation);
    this.formGroup.controls['NewPasswordConfirm'].addValidators(ConfirmPasswordValidation);
  }


  isLoggedIn() {
    return this._authJWTService.isLoggedIn();
  }


  CreateChangePasswordControlProperties () 
  {
    this.changePasswordControl.setFieldControlProperties({
      Group: 'General',
      colNumber: 1,
      rowNumber: 1,
      FieldName: 'CurrentPassword',
      DisplayName: 'CurrentPassword',
      controlType: ControlTypes.Password,
      IsEditable: true,
      IsVisible:  true,
      ShowinOverviewGrid: true,
      DefaultValue: null ,
      Width: 40,
      IsFilterable: true,
    })
    this.changePasswordControl.setFieldControlProperties({
      Group: 'General',
      colNumber: 1,
      rowNumber: 2,
      FieldName: 'NewPassword',
      DisplayName: 'NewPassword',
      controlType: ControlTypes.Password,
      IsEditable: true,
      IsVisible:  true,
      ShowinOverviewGrid: true,
      DefaultValue: null ,
      Width: 200,
      IsFilterable: true,
      Validators: Validators.compose([Validators.maxLength(200)])
    })

    this.changePasswordControl.setFieldControlProperties({
      Group: 'General',
      colNumber: 1,
      rowNumber: 3,
      FieldName: 'NewPasswordConfirm',
      DisplayName: 'NewPasswordConfirm',
      controlType: ControlTypes.Password,
      IsEditable: true,
      IsVisible:  true,
      ShowinOverviewGrid: true,
      DefaultValue: null ,
      Width: 200,
      IsFilterable: true,
    })


  }
  getPasswordError(controlName: string): string | null {
    const control = this.formGroup.get(controlName);
    if (!control) return null;

    if (control.hasError('minlength')) {
      const requiredLength = control.errors?.minlength?.requiredLength;
      return `${this.translateService.instant('PasswordShouldBeAtLeast')} ${requiredLength} ${this.translateService.instant('Digits')}`;
    }
    if (control.hasError('WeakPassword')) {
      return this.translateService.instant('PasswordTooWeak');
    }
    if (control.hasError('TooWeakForMediumPassword')) {
      return `${this.translateService.instant('TooWeakPassword')}, ${this.translateService.instant('MedumPasswordError')}`;
    }
    if (control.hasError('MediumPassword')) {
      return `${this.translateService.instant('WeakPassword')}, ${this.translateService.instant('MedumPasswordError')}`;
    }
    if (control.hasError('TooWeakForComplexPassword')) {
      return `${this.translateService.instant('TooWeakPassword')}, ${this.translateService.instant('ComplexPasswordError')}`;
    }
    if (control.hasError('WeakForComplexPassword')) {
      return `${this.translateService.instant('WeakPassword')}, ${this.translateService.instant('ComplexPasswordError')}`;
    }
    if (control.hasError('ComplexPassword')) {
      return `${this.translateService.instant('MediumPassword')}, ${this.translateService.instant('ComplexPasswordError')}`;
    }
    return null;
  }

  
}
export function CheckStrength(value: string) {
  let strength = 1;
  const rgLowerCase: RegExp = /[a-z]/;
  const rgUpperCase: RegExp = /[A-Z]/;
  const rgNumeric: RegExp = /[0-9]/;
  const rgSpecialChar: RegExp = /[/\|_!@#$%^&*()=+.\-?{}<>]/;
  if (rgLowerCase.test(value)) {
    strength++;
  }
  if (rgUpperCase.test(value)) {
    strength++;
  }
  if (rgNumeric.test(value)) {
    strength++;
  }
  if (rgSpecialChar.test(value)) {
    strength++;
  }
  if (value.length > 14) {
    strength++;
  }
  return strength;
}
export function WeakPassword(control: AbstractControl): ValidationErrors | null {

  if (control.value) {
    if (CheckStrength(control.value) < 3)
      return { PasswordTooWeak: true }; 
  }
  return null;
}
export function MediumPassword(control: AbstractControl): ValidationErrors | null {
  if (control.value) {
    if (CheckStrength(control.value) < 3)
      return { MedumPasswordError: true }; 
    if (CheckStrength(control.value) < 4)
      return { MedumPasswordError: true }; 
  }
  return null; 
}
export function ComplexPassword(control: AbstractControl): ValidationErrors | null {

  if (control.value) {
    if (CheckStrength(control.value) < 3)
      return { ComplexPasswordError: true }; 
    if (CheckStrength(control.value) < 4)
      return { ComplexPasswordError: true }; 
    if (CheckStrength(control.value) < 5)
      return { ComplexPasswordError: true };
  }

  return null; 
}


export function NotMatchingPassword(formGroup: FormGroup): ValidationErrors | null {
  const newPassword = formGroup.get('NewPassword')?.value;
  const confirmPassword = formGroup.get('NewPasswordConfirm')?.value;

  if (newPassword !== confirmPassword) {
    formGroup.controls['NewPasswordConfirm'].setErrors({ 'NotMatchingPassword': true });
    return { NotMatchingPassword: true };
  }

  return null;
}
